/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Fields_HeadingInputs */

const ja_playdata_about_fields_heading = /** @type {(inputs: Playdata_About_Fields_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データ収集の項目`)
};

const en_playdata_about_fields_heading = /** @type {(inputs: Playdata_About_Fields_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What the data covers`)
};

/**
* | output |
* | --- |
* | "What the data covers" |
*
* @param {Playdata_About_Fields_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_about_fields_heading = /** @type {((inputs?: Playdata_About_Fields_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Fields_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_fields_heading(inputs)
	return en_playdata_about_fields_heading(inputs)
});